/**
 * Created by xingbozhang on 17/5/23.
 */
export const ID = '@custom-payment'

export default {
  ID
}
